<template>
  <div>
    <div class="subheading grey--text mt-6 ml-3">
      <h5 v-if="receivedGroups">
        Contact Groups[{{ receivedGroups.totalRecords }}]
      </h5>
    </div>
    <div class="mx-2">
      <v-data-table
        v-if="receivedGroups"
        :headers="headers"
        :items="receivedGroups.groups"
        item-key="name"
        hide-default-footer
        ><template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn
              class="primary white--text lowercase-text"
              plain
              @click="dialogs.create = true"
            >
              Create group
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ item.createdAt | niceDate }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <GroupMenu :group="item" /> </template
      ></v-data-table>
      <div class="text-center mt-8">
        <Pagination
          v-if="receivedGroups"
          store="groups"
          collection="groups"
          action="fetchGroups"
        />
      </div>
    </div>
    <GroupCreate @close="dialogs.create = false" v-if="dialogs.create" />
  </div>
</template>

<script>
import { format } from "date-fns";
import GroupCreate from "./Dialogs/GroupCreate.vue";
import GroupMenu from "./menu/GroupTableMenu";
import Pagination from "@/components/shared/PaginateGlobal";
export default {
  components: { GroupCreate, GroupMenu, Pagination },
  data() {
    return {
      dialogs: {
        create: false,
      },
      expanded: [],
      singleExpand: false,
      headers: [
        {
          text: "Group name",
          align: "start",
          value: "name",
        },
        { text: "Members", value: "members" },
        { text: "Created At", value: "createdAt" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  created() {
    this.$store.dispatch("groups/fetchGroups", 1);
  },
  computed: {
    receivedGroups() {
      return this.$store.getters["groups/groups"];
    },
  },
  filters: {
    niceDate(value) {
      return format(new Date(value), "yyyy-MM-dd h:mm a");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
</style>
